import React from 'react'
import './styles/dashboardimg.css'

const Dashboardimg = () => {
  return (
    <div className='dashboard-img-div'>
        <img src="images/dashboard.png" alt="Dasboard" />
        <div className="white-div"></div>
    </div>
  )
}

export default Dashboardimg;